/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { TrackItMeasurementFilterForCombinationDto } from './TrackItMeasurementFilterForCombinationDto';
import {
    TrackItMeasurementFilterForCombinationDtoFromJSON,
    TrackItMeasurementFilterForCombinationDtoFromJSONTyped,
    TrackItMeasurementFilterForCombinationDtoToJSON,
} from './TrackItMeasurementFilterForCombinationDto';
import type { ISystemSetupCombinationValue } from './ISystemSetupCombinationValue';
import {
    ISystemSetupCombinationValueFromJSON,
    ISystemSetupCombinationValueFromJSONTyped,
    ISystemSetupCombinationValueToJSON,
} from './ISystemSetupCombinationValue';
import type { ParameterCombinationDtoReferenceMeasurementInfo } from './ParameterCombinationDtoReferenceMeasurementInfo';
import {
    ParameterCombinationDtoReferenceMeasurementInfoFromJSON,
    ParameterCombinationDtoReferenceMeasurementInfoFromJSONTyped,
    ParameterCombinationDtoReferenceMeasurementInfoToJSON,
} from './ParameterCombinationDtoReferenceMeasurementInfo';
import type { IConditionValueAssignment } from './IConditionValueAssignment';
import {
    IConditionValueAssignmentFromJSON,
    IConditionValueAssignmentFromJSONTyped,
    IConditionValueAssignmentToJSON,
} from './IConditionValueAssignment';

/**
 * 
 * @export
 * @interface ParameterCombinationDto
 */
export interface ParameterCombinationDto {
    /**
     * 
     * @type {string}
     * @memberof ParameterCombinationDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ParameterCombinationDto
     */
    combinationId?: string;
    /**
     * 
     * @type {string}
     * @memberof ParameterCombinationDto
     */
    hash?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ParameterCombinationDto
     */
    targetSystemId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ParameterCombinationDto
     */
    supportSystemEntityIds?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ParameterCombinationDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ParameterCombinationDto
     */
    category?: string | null;
    /**
     * 
     * @type {Array<ISystemSetupCombinationValue>}
     * @memberof ParameterCombinationDto
     */
    targetSystemValues?: Array<ISystemSetupCombinationValue> | null;
    /**
     * 
     * @type {Array<ISystemSetupCombinationValue>}
     * @memberof ParameterCombinationDto
     */
    supportSystemValues?: Array<ISystemSetupCombinationValue> | null;
    /**
     * 
     * @type {ParameterCombinationDtoReferenceMeasurementInfo}
     * @memberof ParameterCombinationDto
     */
    referenceMeasurementInfo?: ParameterCombinationDtoReferenceMeasurementInfo | null;
    /**
     * 
     * @type {Array<TrackItMeasurementFilterForCombinationDto>}
     * @memberof ParameterCombinationDto
     */
    trackItFilters?: Array<TrackItMeasurementFilterForCombinationDto> | null;
    /**
     * 
     * @type {Array<IConditionValueAssignment>}
     * @memberof ParameterCombinationDto
     */
    readonly conditionValueAssignments?: Array<IConditionValueAssignment> | null;
    /**
     * 
     * @type {string}
     * @memberof ParameterCombinationDto
     */
    $type?: ParameterCombinationDtoTypeEnum;
}


/**
 * @export
 */
export const ParameterCombinationDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoParameterCombinationsParameterCombinationDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.ParameterCombinations.ParameterCombinationDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ParameterCombinationDtoTypeEnum = typeof ParameterCombinationDtoTypeEnum[keyof typeof ParameterCombinationDtoTypeEnum];



/**
 * Check if a given object implements the ParameterCombinationDto interface.
 */
export function instanceOfParameterCombinationDto(value?: unknown): value is ParameterCombinationDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ParameterCombinationDtoTypeEnum)[0];
}

export function ParameterCombinationDtoFromJSON(json: any): ParameterCombinationDto {
    return ParameterCombinationDtoFromJSONTyped(json, false);
}

export function ParameterCombinationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParameterCombinationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'combinationId': json['combinationId'] == null ? undefined : json['combinationId'],
        'hash': json['hash'] == null ? undefined : json['hash'],
        'targetSystemId': json['targetSystemId'] == null ? undefined : json['targetSystemId'],
        'supportSystemEntityIds': json['supportSystemEntityIds'] == null ? undefined : json['supportSystemEntityIds'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'category': json['category'] == null ? undefined : json['category'],
        'targetSystemValues': json['targetSystemValues'] == null ? undefined : ((json['targetSystemValues'] as Array<any>).map(ISystemSetupCombinationValueFromJSON)),
        'supportSystemValues': json['supportSystemValues'] == null ? undefined : ((json['supportSystemValues'] as Array<any>).map(ISystemSetupCombinationValueFromJSON)),
        'referenceMeasurementInfo': json['referenceMeasurementInfo'] == null ? undefined : ParameterCombinationDtoReferenceMeasurementInfoFromJSON(json['referenceMeasurementInfo']),
        'trackItFilters': json['trackItFilters'] == null ? undefined : ((json['trackItFilters'] as Array<any>).map(TrackItMeasurementFilterForCombinationDtoFromJSON)),
        'conditionValueAssignments': json['conditionValueAssignments'] == null ? undefined : ((json['conditionValueAssignments'] as Array<any>).map(IConditionValueAssignmentFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function ParameterCombinationDtoToJSON(value?: Omit<ParameterCombinationDto, 'conditionValueAssignments'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'combinationId': value['combinationId'],
        'hash': value['hash'],
        'targetSystemId': value['targetSystemId'],
        'supportSystemEntityIds': value['supportSystemEntityIds'],
        'isEnabled': value['isEnabled'],
        'category': value['category'],
        'targetSystemValues': value['targetSystemValues'] == null ? undefined : ((value['targetSystemValues'] as Array<any>).map(ISystemSetupCombinationValueToJSON)),
        'supportSystemValues': value['supportSystemValues'] == null ? undefined : ((value['supportSystemValues'] as Array<any>).map(ISystemSetupCombinationValueToJSON)),
        'referenceMeasurementInfo': ParameterCombinationDtoReferenceMeasurementInfoToJSON(value['referenceMeasurementInfo']),
        'trackItFilters': value['trackItFilters'] == null ? undefined : ((value['trackItFilters'] as Array<any>).map(TrackItMeasurementFilterForCombinationDtoToJSON)),
        '$type': value['$type'],
    });
}

